/*
 * $Id:: TableSortHead.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { t } from '../../../../../providers';

const TableSortHead = ({ classes, sortBy, sortValue, setSorting, readOnly }) => {
    const sortHeader = (event, sortByType) => {
        event.preventDefault();
        setSorting(sortByType);
    };

    return (
        <TableHead>
            <TableRow className={classes.row}>
                <TableCell className={classes.name} align="left">
                    <TableSortLabel active={sortBy === 'firstName'} direction={sortValue} onClick={(event) => sortHeader(event, 'firstName')}>
                        {t('name')}
                    </TableSortLabel>
                </TableCell>
                <TableCell className={classes.email} align="left">
                    <TableSortLabel active={sortBy === 'email'} direction={sortValue} onClick={(event) => sortHeader(event, 'email')}>
                        {t('email')}
                    </TableSortLabel>
                </TableCell>
                <TableCell className={classes.status} align="left">
                    <TableSortLabel active={sortBy === 'status'} direction={sortValue} onClick={(event) => sortHeader(event, 'status')}>
                        {t('status')}
                    </TableSortLabel>
                </TableCell>
                <TableCell className={classes.roles} align="left">
                    {t('roles')}
                </TableCell>
                <TableCell className={classes.lastLogin} align="left">
                    <TableSortLabel
                        active={sortBy === 'lastLoginDateTime'}
                        direction={sortValue}
                        onClick={(event) => sortHeader(event, 'lastLoginDateTime')}>
                        {t('last.login')}
                    </TableSortLabel>
                </TableCell>
                {!readOnly && <TableCell className={classes.actions} align="left"></TableCell>}
            </TableRow>
        </TableHead>
    );
};

export default TableSortHead;
